import React from 'react';
import SidewalkRampMap from '../components/SidewalkRampMap';
import PageShell from '../components/PageShell';

const SidewalkRampPage = () => (
  <PageShell
    title="Sidewalk ramp"
    subtitle="Map tooling for sidewalk ramp requests (separate from GovOps permits)."
  >
    <SidewalkRampMap />
  </PageShell>
);

export default SidewalkRampPage;
